import type { InjectionKey, ModelRef, UnwrapNestedRefs } from 'vue';
import { computed, ref } from 'vue';
import Core from '@/core/core/core';
import { defineStore, useStore, type Store as DefineStore } from '@/core/utils/store';
import StoreLocalStorage from '@/core/utils/store/localStorage';
import type { Props, Store } from './types';
import { getHash } from '@/core/utils/route';

const popstateCallbacks = new Set<(e: PopStateEvent) => void>();

addEventListener('popstate', (e) => {
	popstateCallbacks.forEach(popstateCallback => popstateCallback(e));
});

export const injectionKey = Symbol() as InjectionKey<Store>;

/**
 * Инициировать Store компонента
 */
export const defineTabsStore = (props: Props, model: ModelRef<string | undefined>): UnwrapNestedRefs<Store> & DefineStore => {
	const store = defineStore(injectionKey, () => {
		const showMenuInPopup = computed(() => props.showMenuInPopup ?? Core.state.isMobile);
		const pageMod = computed(() => props.pageMod);
		const isShort = ref(false);

		const component = ref(undefined);
		const scrollable = ref(true);

		return {
			showMenuInPopup,
			pageMod,
			isShort,
			activeItemName: model,
			component,
			scrollable,
		};
	}, props.idState);

	if (props.isShortable) {
		const stateName = 'isShort';

		StoreLocalStorage.loadLocalStorge(stateName, store);
		StoreLocalStorage.addSaverLocalStorge(stateName, store);
	}

	if (store.$id) {
		const popstateCallback = (_e: PopStateEvent) => {
			model.value = getHash(store.$id!);
		};

		popstateCallbacks.add(popstateCallback);
	}

	return store;
};

/**
 * Получить Store компонента
 */
export const useTabsStore = () => useStore(injectionKey);
